<template>
  <div>
    <el-form ref="formLms" :model="formData" label-position="top" :rules="rules">
      <el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="파일 저장" label-width="120px">
              <el-switch v-model="formData.logInfo.logSaveFileFlag" active-value="Y" inactive-value="N" @change="changeFileSaveFlag"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="파일 보관주기" label-width="120px">
              <el-input-number v-model="formData.logInfo.retentionAge" controls-position="right" :disabled="formData.logInfo.logSaveFileFlag === 'N'" :min="1" :max="9999">
              </el-input-number> 일
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="파일 암호화" label-width="120px">
            <el-switch :disabled="formData.logInfo.logSaveFileFlag === 'N'" v-model="formData.logInfo.encryptFlag" active-value="Y" inactive-value="N"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="비밀번호" label-width="120px" prop="encryptPw">
            <el-input v-show="!checkPwFlag()" v-model="formData.logInfo.encryptPw" type="password" :disabled="formData.logInfo.encryptFlag === 'N'"></el-input>
            <el-button type="primary" v-show="checkPwFlag()" :disabled="formData.logInfo.encryptFlag === 'N'" @click="onToggleChangePwFlag">비밀번호 변경</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="파일 압축" label-width="120px">
            <el-switch v-model="formData.logInfo.compressFlag" active-value="Y" inactive-value="N" :disabled="formData.logInfo.logSaveFileFlag === 'N'"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="머신러닝 패턴 사용" label-width="120px">
            <span slot="label">
              <span class="mr-r4">머신러닝 패턴 사용</span>
              <el-popover placement="bottom" width="500" trigger="hover" :offset="40">
                <span class="text"> - 머신러닝 패턴은 같은 패턴의 로그가 <em>25개 </em>이상 발생해야 생성됩니다.</span>
                <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
              </el-popover>
            </span>
            <el-switch v-model="formData.logInfo.mlFlag" active-value="Y" inactive-value="N"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="저장소">
            <el-select v-model="dataindexId" @change="loadPattern" style="width:100%">
              <el-option label="미배정" :value="null" />
              <el-option v-for="index in dataindexes" :key="index.dataindexId" :label="index.dataindexName" :value="index.dataindexId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="파싱 패턴" prop="patternId">
            <el-select v-model="patternId" :disabled="!dataindexId" @change="setPatternId" style="width:100%">
              <el-option v-for="item in patternList" :key="item.patternId" :label="item.patternName" :value="item.patternId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="파싱 패턴 정규식" label-width="120px">
          <el-input
            readOnly
            type="textarea"
            :rows="4"
            resize="none"
            v-model="parsingPattern">
          </el-input>
      </el-form-item>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="연동 장비 선택" label-width="120px">
            <span slot="label">
              <span class="mr-r4">연동 장비 선택</span>
              <el-popover placement="bottom" width="500" trigger="hover" :offset="40">
                <span class="text"> - 서버와 IP가 같은 장비입니다 <br/> - 연동한 장비는 <em>성능/운영 > 분석 </em>에서 로그를 확인할 수 있습니다.</span>
                <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
              </el-popover>
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-select v-model="relatedObj" @change="changeRelatedObj" style="width:100%">
            <el-option label="미선택" :value="null" />
            <el-option v-for="(item, index) in objLinkList" :key="index" :label="item.ObjName" :value="item.objId"></el-option>
          </el-select>
        </el-col>
      </el-row>
    </el-form>
    <w-applog-pw-change-popup ref="applogPwChangePopup" :formData="formData"></w-applog-pw-change-popup>
  </div>
</template>

<script>
import LmsApplogAPI from '@/api/settings/log/lms-applog-setting';
import IntegratedSyslogSettingAPI from '@/api/settings/log/integrated-syslog-settings';
import { isNil, isEmpty } from 'lodash';
import msgUtils from '@/utils/message';
import WApplogPwChangePopup from '../popup/AppLogPwChangePopup';

export default {
  name: 'WApplogLmsSetting',
  data() {
    const patternValidation = (rule, value, callback) => {
      if (!isNil(this.dataindexId) && isNil(this.patternId)) {
        callback(new Error('패턴을 선택해주세요.'));
      } else {
        callback();
      }
    };
    const pwValidation = (rule, value, callback) => {
      if (!this.checkPwFlag()) {
        if (this.formData.logInfo.encryptFlag === 'Y' && !this.checkPwFlag() && isEmpty(this.formData.logInfo.encryptPw)) {
          callback(new Error('비밀번호를 입력해주세요.'));
        } else if (this.formData.logInfo.encryptFlag === 'Y' && this.formData.logInfo.encryptPw.length > 255) {
          callback(new Error(msgUtils.getStringLengthValidationMsgData(255)));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      dataindexId: null,
      patternId: null,
      dataindexes: [],
      rules: {
        patternId: [
          { validator: patternValidation, trigger: 'blur' },
        ],
        encryptPw: [
          { validator: pwValidation, trigger: 'blur' },
        ],
      },
      relatedObj: null,
      parsingPattern: null,
      objLinkList: [],
      patternList: [],
      selectObj: null,
    };
  },
  props: {
    isAdd: {
      type: Boolean,
    },
    formData: {
      type: Object,
    },
  },
  components: {
    WApplogPwChangePopup,
  },
  methods: {
    loadDataindex() {
      IntegratedSyslogSettingAPI.getDataIndexes().then((response) => {
        if (response.data.success) {
          this.dataindexes = response.data.data;
          this.dataindexId = null;
          if (!isNil(this.formData.logInfo.dataindexId)) {
            this.dataindexId = this.formData.logInfo.dataindexId;
          }
          this.loadPattern(this.dataindexId);
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '저장소', false));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '저장소', false));
        throw new Error(e);
      });
    },
    loadPattern(value) {
      this.formData.logInfo.patternId = null;
      this.patternId = null;
      this.parsingPattern = null;
      this.formData.logInfo.dataindexId = value;
      if (!isNil(value)) {
        const params = {
          params: {
            dataindexId: value,
          },
        };
        IntegratedSyslogSettingAPI.getPatternByIndex(params).then((response) => {
          if (response.data.success) {
            this.patternList = response.data.data;
            if (!isEmpty(this.patternList)) {
              this.patternId = this.patternList[0].patternId;
              this.setPatternId(this.patternId);
            } else {
              this.$message(msgUtils.getCustomMsgData('패턴을 생성해주세요.'));
            }
          } else {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '패턴', false));
          }
        }).catch((e) => {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '패턴', false));
          throw new Error(e);
        });
      }
    },
    setPatternId(value) {
      this.parsingPattern = null;
      this.formData.logInfo.patternId = value;
      const pattern = this.patternList.find((item) => (item.patternId === value));
      this.parsingPattern = pattern.patternRegex;
    },
    changeRelatedObj(data) {
      this.formData.objLinkId = data;
    },
    onToggleChangePwFlag() {
      this.$refs.applogPwChangePopup.open();
    },
    /**
     * 비밀번호 설정 여부 확인
     * @author leesy918
     * @return {[type]} [description]
     */
    checkPwFlag() {
      return this.formData.checkEncryptFlag === 'Y';
    },
    /**
     * data 초기화
     * @author leesy918
     */
    resetData() {
      this.dataindexId = null;
      this.patternId = null;
      this.updateEncryptPwCheck = null;
      this.checkPassword = null;
      this.patternList = [];
      this.objLinkList = [];
      this.parsingPattern = null;
    },
    /**
     * 파일 저장설정 변경 함수
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    changeFileSaveFlag(data) {
      if (data === 'Y') {
        this.formData.logInfo.retentionAge = 1;
      } else {
        this.formData.logInfo.retentionAge = null;
        this.formData.logInfo.encryptFlag = 'N';
        this.formData.logInfo.compressFlag = 'N';
        this.formData.logInfo.encryptPw = null;
      }
    },
    /**
     * 패스워드 활성화 함수
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    changePasswordSwitch(data) {
      if (data === 'N') {
        this.formData.logInfo.encryptPw = null;
      }
    },
    /**
     * 초기 데이터 로드 (연동 장비 목록, 파싱 패턴 목록)
     * @author leesy918
     * @param  {[type]} serverId [description]
     * @return {[type]}          [description]
     */
    getApplogSettingData(serverId) {
      this.getLinkObjList(serverId);
      this.loadDataindex();
    },
    /**
     * 장비 연동 목록 조회 (server와 ipaddress가 같은 obj 목록을 조회한다).
     * @author leesy918
     * @return {[type]} [description]
     */
    getLinkObjList(serverId) {
      const params = {
        serverId,
      };
      LmsApplogAPI.getLinkObjList(params).then((response) => {
        if (response.data.success) {
          this.objLinkList = response.data.data;
          if (isNil(this.formData.objLinkId)) {
            this.relatedObj = null;
          } else {
            this.relatedObj = this.formData.objLinkId;
          }
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '연동 장비', false));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '연동 장비', false));
        throw new Error(e);
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/Applog/component/ApplogLmsSetting.vue